import React, { Component } from "react"
import {employStatus, oneTill4plus, employQuality, employSocial, noYes, 
      employNewBuisness, employVolunteer } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'


export const  Employment_microLegend = {
    "employ_status": "מצב תעסוקתי",
    "employ_prev_places": "מקומות במקביל", // number
    "employ_cap_hours": "שעות בשבוע (כולל)",
    "employ_main": "מקום עבודה עיקרי",
    "employ_role": "תפקיד",
    "employ_quality": "שביעות רצון",
    "employ_current_place": "מקום עבודה נוכחי",
    "employ_cap_percent": "אחוז משרה",
    "employ_social": "סוג העבודה",
    "employ_duration": "וותק (בחודשים)",
    "employ_bruto": "משכורת ברוטו",
    "employ_neto": "משכורת נטו",
    "employ_comments": "הערות",
    "employ_interest_inchange": "ענין בשינוי תעסוקתי",
    "employ_i1": "למצוא מקום עבודה",
    "employ_i2": "להוסיף עוד מקום עבודה",
    "employ_i3": "להחליף מקום עבודה",
    "employ_i4": "לשדרג מקום עבודה",
    "employ_i5": "לא מעוניין בשינוי",
    "employ_i6": "אחר",
    "employ_new_buisness": "האם מעוניין/ת לפתוח עסק / להרחיב קיים?",
    "employ_new_buis_other": "אם אחר, פרט",
    "employ_last3y" : "בכמה מקומות עבדת ב 3 שנים אחרונות",
    "employ_volunteer": "האם מתנדב/ת או פעיל/ה מבחינה ציבורית?"
}
const emptyProduct = [{
  "employ_status": "",
  "employ_prev_places": "",
  "employ_cap_hours": "",
  "employ_main": "",
  "employ_role": "",
  "employ_quality": "",
  "employ_current_place": "",
  "employ_cap_percent": "",
  "employ_social": "",
  "employ_duration": "",
  "employ_bruto": "",
  "employ_neto": "",
  "employ_comments": "",
  "employ_interest_inchange": "",
    "employ_i1": "",
    "employ_i2": "",
    "employ_i3": "",
    "employ_i4": "",
    "employ_i5": "",
    "employ_i6": "",
    "employ_new_buisness":"",
    "employ_new_buis_other": "",
    "employ_last3y" : "",
    "employ_volunteer": ""
}]
export class ParentEmployment extends Component {

    constructor(props) {
      super(props)
      this.state = { products: typeof this.props.data === "undefined" ? emptyProduct :  this.props.data}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
     
     // if (typeof products !== "undefined")
      var product = products
      const cellData=[{
            type: "select",
            options: employStatus, // ["שכיר","עצמאי","גם שכיר וגם עצמאי","עבודה בשחור","גם שכיר וגם עבודה בשחור","עקר/ת בית",
                  //"מובטל","פנסיונר","בחופשת לידה","מקבל מלגת עבודה","אחר"],
            name: "employ_status",
            value: product.employ_status,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "select",
            options: oneTill4plus, // ["1","2","3","4+"],
            name: "employ_prev_places",
            value: product.employ_prev_places,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "employ_cap_hours",
            value: product.employ_cap_hours,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "employ_main",
            value: product.employ_main,
            id: product.id,
            style: {width: "190px"},
            edit: true
          },{
            type: "text",
            name: "employ_role",
            value: product.employ_role,
            id: product.id,
            style: {width: "130px"},
            edit: true
          },{
            type: "select",
            options: employQuality, // ["תואם לכישורים", "במידה בינונית", "מתחת להשכלה וכישורים", "כלל לא"],
            name: "employ_quality",
            value: product.employ_quality,
            id: product.id,
            style: {width: "160px !important"},
            edit: true
          },{
            newsection: "מקום עבודה נוכחי",
            type: "text",
            name: "employ_current_place",
            value: product.employ_current_place,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "text",
            name: "employ_cap_percent",
            value: product.employ_cap_percent,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "select",
            options: employSocial, //[" קבועה (גם אם אין קביעות)", "זמנית", "מזדמנת", "מועסקת במהלך השנה ומפוטרת בחדשי הקיץ"],
            name: "employ_social",
            value: product.employ_social,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "text",
            name: "employ_duration",
            value: product.employ_duration,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "employ_bruto",
            value: product.employ_bruto,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "employ_neto",
            value: product.employ_neto,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "textarea",
            name: "employ_comments",
            value: product.employ_comments,
            id: product.id,
            style: {width: "190px"},
            edit: true
          },{
            newsection: "",
            type: "select",
            options: ["0","1","2","3", "4+"],
            name: "employ_last3y",
            value: product.employ_last3y,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            newsection: "ענין בשינוי תעסוקתי",
            type: "text",
            name: "employ_interest_inchange",
            value: product.employ_interest_inchange,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "employ_i1",
            value: product.employ_i1,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "employ_i2",
            value: product.employ_i2,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "employ_i3",
            value: product.employ_i3,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: noYes,  // ["לא","כן"],,
            name: "employ_i4",
            value: product.employ_i4,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: noYes,  // ["לא","כן"],,
            name: "employ_i5",
            value: product.employ_i5,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "employ_i6",
            value: product.employ_i6,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            newsection:"",
            type: "select",
            options: employNewBuisness, // ["מעוניין לפתוח עסק חדש","מעוניין להרחיב עסק קיים","לא מעוניין","אחר"],
            name: "employ_new_buisness",
            value: product.employ_new_buisness,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "text",
            name: "employ_new_buis_other",
            value: product.employ_new_buis_other,
            id: product.id,
            style: {width: "500px"},
            edit: true
          },{
            newsection:"התנדבות ופעילות ציבורית",
            type: "select",
            options: employVolunteer, // ["כן","לא מתנדב, וגם לא מעוניין בכך","מעוניין להתנדב אך לא עושה זאת בפועל","אחר"],
            name: "employ_volunteer",
            value: product.employ_volunteer,
            id: product.id,
            style: {width: "230px"},
            edit: true
          }] 
          

      return (box_element(tableTitle, onSaveTable, onProductTableUpdate, product, cellData, Employment_microLegend))
    }
  }

export const box_element = (tableTitle, onSaveTable, onProductTableUpdate, product, cellData, labels, onProductTableDate = null  ) => {
  return (
    <div className="sub-tab">
        <h2 className="sub-tab-title">{tableTitle}</h2>
        
        <button type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
        
        <div className="mynewdivform ">
            <ProductRow 
                onProductTableUpdate={onProductTableUpdate} 
                product={product} 
                cd={cellData}
                labels = {labels}
                onProductTableDate = { onProductTableDate}
                />
        </div>
    </div>
  )
}
class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, labels, onProductTableDate} = this.props
      var key = 0;
      return (
        <div className="eachRow family-program-info">
          {cd.map(cellInfo => {
              if (typeof cellInfo.newsection !== "undefined")
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} onProductTableDate={onProductTableDate} labels={labels}/>
                </React.Fragment>
                )
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} onProductTableDate={onProductTableDate} labels={labels} /> )
          })}
  
        </div>
      )
  
    }
  
  }

  class EditableFormCell extends React.Component {
    handleChange = changeEvent => {
      this.setState({date: changeEvent.target.value})
      //this.props.onChange(changeEvent)
    }
    render() {
        const tp = this.props
        const tpc = tp.cellData
        const labels = tp.labels
        //const divStyle = {padding: 0, borderTop: 0, display: 'inline-block',margin: '0 3px 0 8px', verticalAlign:'top'}
        if (tpc.type === "date"){
          return (
             <div className="form-cell-box-inline">
               <label htmlFor={tpc.id}>{labels[tpc.name]}</label>
               {<CalendarDay2
                   tpc = {tpc}
                   value = {tpc.value}
                   selected={new Date()}
                   onChange={this.handleChange}
                   handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
               />}
             </div>
           )
        }
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{labels[tpc.name]}</label><br />
              <SelectF tp={tp} tpc={tpc}  />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{labels[tpc.name]}</label><br />
              <TextareaF tp={tp} tpc={tpc} />
            </div>
          )
        }
        return (
          <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{labels[tpc.name]}</label><br />
              <InputF tpc={tpc} tp={tp} />
          </div>
        )
  
    }
  }
